import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import Day from '../Day';
import { getCalendarDates, isSameDay } from '../helpers';
/**
 * Week
 *
 * This component is in charge of displaying
 * a week
 *
 * @param {string} className - Class needed by styled component.
 * @param {string} currentDate - The current month.
 * @param {string} selected - The selected date.
 * @param {string} startDate - The selected start date.
 * @param {string} endDate - The selected end date.
 * @param {string} onDateClick - Date click handler.
 *
 * @return {jsx}
 */

var Weeks = function Weeks(_ref) {
  var className = _ref.className,
      currentMonth = _ref.currentMonth,
      displayOnlyInMonth = _ref.displayOnlyInMonth,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      onDateClick = _ref.onDateClick,
      selected = _ref.selected,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, getCalendarDates(currentMonth).map(function (date) {
    // Normalize date from date object
    // @see: https://moment.github.io/luxon/docs/class/src/datetime.js~DateTime.html#static-method-fromJSDate
    var dateNormalized = DateTime.fromObject(date); // Check if calendar date is in the same month as the state month and year

    var monthStart = dateNormalized.startOf('month');
    var isInMonth = monthStart.hasSame(currentMonth, 'month'); // Check if selected date is in range

    var isInRange = (!minDate || dateNormalized >= minDate.startOf('day')) && (!maxDate || dateNormalized <= maxDate.startOf('day'));
    var isSelected = selected && isInRange && isSameDay(dateNormalized, selected);
    var startOfDay = dateNormalized.startOf('day');
    var isInPath = isInRange && startDate && endDate && startOfDay >= startDate && startOfDay <= endDate;
    var isStartEdge = !!startDate && isInRange && isSameDay(dateNormalized, startDate);
    var isEndEdge = !!endDate && isInRange && isSameDay(dateNormalized, endDate);
    var day = dateNormalized.day; // Do not trigger onlick if the day is disabled (below minDate or after maxDate)

    var onDayClick = function onDayClick() {
      return isInRange && onDateClick(dateNormalized);
    };

    return /*#__PURE__*/React.createElement(Day, {
      key: dateNormalized,
      disabled: !isInRange,
      shadowed: !isInMonth,
      displayOnlyInMonth: displayOnlyInMonth,
      isSelected: isSelected,
      isInPath: isInPath,
      isStartEdge: isStartEdge,
      isEndEdge: isEndEdge,
      onClick: onDayClick
    }, day);
  }));
};

var bool = PropTypes.bool,
    string = PropTypes.string,
    object = PropTypes.object,
    func = PropTypes.func;
Weeks.propTypes = {
  className: string,
  currentMonth: object.isRequired,
  displayOnlyInMonth: bool,
  selected: object,
  startDate: object,
  endDate: object,
  minDate: object,
  maxDate: object,
  onDateClick: func
};
Weeks.defaultProps = {
  className: '',
  displayOnlyInMonth: false,
  minDate: null,
  maxDate: null,
  onDateClick: function onDateClick() {},
  selected: null,
  startDate: null,
  endDate: null
};
export default styled(Weeks).withConfig({
  displayName: "Weeks",
  componentId: "uggog9-0"
})(["display:flex;flex-wrap:wrap;"]);